export default function About() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            关于90影院
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            了解我们的初心与坚持
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/60">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500/15 flex items-center justify-center">
              <i className="ri-movie-2-line text-3xl md:text-4xl text-primary-500"></i>
            </div>
            <div>
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-4">
                为8090后打造的免费高清影视乐园
              </h3>
              <div className="space-y-3">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  <strong className="text-primary-500 font-semibold">90影院</strong>诞生于对影视的热爱。我们深知8090后观众对内容品质和观影体验的追求——既要片源丰富、更新及时，又要画质清晰、播放流畅、完全免费。基于这样的初心，我们聚合了电影、电视剧、综艺、动漫等全品类资源，搭建起这个一站式免费观影平台。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  依托智能CDN加速与多重备用线路技术，90影院的在线观看体验始终保持行业领先水平，真正做到<strong className="text-accent-400 font-semibold">不缓冲、不卡顿、不收费</strong>。每天50+内容更新，10万+片源持续扩充，涵盖动作、喜剧、悬疑、科幻、爱情、古装等全题材，满足每一位观众的口味。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  未来，90影院将继续优化观影体验，扩充更多优质片源，陪伴8090后的每一个观影时光。无论是下班后的放松时刻，还是周末的追剧马拉松，90影院始终在这里，为你点亮精彩世界。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}